import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { basicStoresListQueries } from '@/services/basicStores/basicStores.queries';

export const useGetStoreDetails = (clubId: string) => {
  const { data, isSuccess, isLoading } = useQuery({
    ...basicStoresListQueries.detail({
      clubId: clubId || '',
    }),
  });

  return {
    getBasicStoreDetails: data?.data,
    isSuccess,
    isLoading,
  };
};
